import {
  GridFilterItem,
  GridFilterOperator,
  getGridDateOperators,
  getGridStringOperators,
} from '@mui/x-data-grid-pro';

import { SingleOperators } from 'common/src/query-params/operators';

import {
  BillAmountInputValue,
  DateRangePickerComponent,
  MultipleSelectorComponent,
  SingleSelectorComponent,
} from './CustomCollectorComponents';
import {
  customArrayOperators,
  customSingleOperators,
} from './CustomFilterOperators';

const getFilterValueLabel = (str: string): string =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`.split(/(?=[A-Z])/).join(' ');

const getCustomStringFilterOperaters = (): GridFilterOperator[] =>
  getGridStringOperators().filter(({ value }) =>
    ['contains', 'doesNotContain', 'doesNotEqual', 'equals'].includes(value),
  );

const getServerSideStringOperatorValie = (value: string): SingleOperators => {
  switch (value) {
    case 'contains':
      return SingleOperators.LIKE;
    case 'doesNotContain':
      return SingleOperators.NOT_LIKE;
    case 'doesNotEqual':
      return SingleOperators.NOT_EQUAL_TO;
    case 'equals':
      return SingleOperators.EQUALS;
  }
};

export const dateRangeOperator: GridFilterOperator = {
  label: 'Is Between',
  value: 'between',
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.value || filterItem.value.length !== 2) return null;
    const [start, end] = filterItem.value.map((date) =>
      date ? new Date(date) : null,
    );

    return (params): boolean => {
      const { value: cellDate } = params;
      if (!cellDate) return false;

      const isAfterStart = !start || cellDate >= start;
      const isBeforeEnd = !end || cellDate <= end;
      return isAfterStart && isBeforeEnd;
    };
  },
  InputComponent: (props) =>
    DateRangePickerComponent({ ...props, size: 'small' }),
};

export const combineFilterOperators = ({
  singleOperators,
  multipleOperators,
}: {
  singleOperators: GridFilterOperator[];
  multipleOperators: GridFilterOperator[];
}): GridFilterOperator[] => {
  return [...singleOperators, ...multipleOperators];
};

export const customDateFilter = () => {
  const { ...model } = getGridDateOperators()[0];
  const operators = customSingleOperators;
  return operators.map((operator) => {
    model.label = operator.label;
    model.value = operator.value;
    return { ...model };
  });
};

export const customNumberFilter = () => {
  const { ...model } = getGridStringOperators()[0];
  model.InputComponent = BillAmountInputValue;
  const operators = customSingleOperators;
  return operators.map((operator) => {
    model.label = operator.label;
    model.value = operator.value;
    model.getApplyFilterFn = (filterItem) => {
      return filterItem as any;
    };
    return { ...model };
  });
};

export const clientSideStringFilterOperators: GridFilterOperator[] =
  getCustomStringFilterOperaters().map((operator) => ({
    ...operator,
    label: getFilterValueLabel(operator.value),
  }));

export const serverSideStringFilterOperators: GridFilterOperator[] =
  getCustomStringFilterOperaters().map((operator) => ({
    ...operator,
    label: getFilterValueLabel(operator.value),
    value: getServerSideStringOperatorValie(operator.value),
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      return filterItem as any;
    },
  }));

export const multipleFilterOperators = (props): GridFilterOperator[] => {
  return customArrayOperators.map((item) => ({
    ...item,
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      return filterItem as any;
    },
    InputComponent: MultipleSelectorComponent as any,
    InputComponentProps: { ...props },
  }));
};

export const singleSelectFilter = (
  props,
  opExcluded = [],
): GridFilterOperator[] => {
  const operators = customSingleOperators.filter(
    ({ value }) => opExcluded.indexOf(value as any) === -1,
  );
  return operators.map((operator) => ({
    ...operator,
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      return filterItem as any;
    },
    InputComponent: SingleSelectorComponent as any,
    InputComponentProps: { ...props },
  }));
};
